import { render, staticRenderFns } from "./NDCFormDialog.vue?vue&type=template&id=27164682"
import script from "./NDCFormDialog.vue?vue&type=script&lang=js"
export * from "./NDCFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports